import React from "react";
import Button from "app/components/Button";
import { signInWithGoogle, auth } from "utils/firebase";
import google from "../../../../../assets/svgs/ic_google.svg";
import { useDispatch, useSelector } from "react-redux";
import { userOnboardingStage } from "app/types";
import { useNavigate } from "react-router-dom";
import { actions as appActions } from "app/redux/slice";
import { selectIsGoogleLogin } from "../../redux/selector";
import { actions } from "../../redux/slice";

export default function GoogleButton() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isGoogleLogin = useSelector(selectIsGoogleLogin);

  const responseGoogle = (response: any) => {
    const googleData = {
      email: response[0].email,
      fullName: response[0].displayName,
      profilePic: response[0].photoURL,
      googleId: response[0].uid,
    };

    dispatch(
      actions.doGoogleLogin({
        data: googleData,
        callback: (nextPage: userOnboardingStage, fullName, token) => {
          localStorage.setItem("accessToken", token);
          if (nextPage === userOnboardingStage.CREATE_PROFILE) {
            navigate(
              `/onboarding/create-profile?isGoogleLogin=true&userName=${fullName}`
            );
          } else if (nextPage === userOnboardingStage.COMPLETED) {
            dispatch(appActions.doGetMyProfile());
            dispatch(appActions.doGetUserWorkspace({ callback() {} }));
            navigate(`/app/home`);
          }
        },
      })
    );
  };

  React.useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user: any) => {
      if (user) responseGoogle(user.providerData);
    });
    return () => {
      unsubscribe();
      auth.signOut();
    };
  }, []);

  return (
    <Button
      className="w-full h-[56px] flex items-center justify-center"
      type="button"
      isLoading={isGoogleLogin}
      onClick={() => signInWithGoogle().catch(() => {})}
    >
      <div className="flex items-center gap-[10px]">
        <img sizes="24px" src={google} alt="Google" />
        <span>Continue with Google</span>
      </div>
    </Button>
  );
}
